export default {
  交易赢巴萨球票: `交易赢巴萨球票
<br class="h1-br" />亲临<span>巴萨</span>25/26赛季主场`,
  在全球最佳EBC交易:
    "在全球最佳券商EBC交易，即可赢取巴塞罗那足球俱乐部主场球票，机票、酒店全程礼遇，见证红蓝军团在绿茵场上的精彩演绎",
  立即参与: "立即参与",
  达成交易目标: "达成交易目标 领取观赛豪礼",
  在活动期间完成指定净入金与交易量:
    "在活动期间内，单月完成指定净入金与交易量，尊享非凡观赛之旅。",
  查看赛程: "查看赛程",
  "*净入金达到20,000 USD": "*净入金达到20,000 USD&nbsp;&nbsp; 即可获得",
  "巴塞罗那足球俱乐部普通球票×1": "巴塞罗那足球俱乐部<br />普通球票×1",
  "*净入金达到 40,000 USD": "*净入金达到 40,000 USD&nbsp;&nbsp; 即可获得",
  "巴塞罗那足球俱乐部普通球票×2": "巴塞罗那足球俱乐部<br />普通球票×2",
  "*净入金达到 50,000 USD": "*净入金达到 50,000 USD&nbsp;&nbsp; 即可获得",
  "巴塞罗那足球俱乐部VIP球票×1": "巴塞罗那足球俱乐部<br />VIP球票×1",
  "*净入金达到100,000 USD": "*净入金达到100,000 USD&nbsp;&nbsp; 即可获得",
  "巴塞罗那足球俱乐部VIP球票×2": "巴塞罗那足球俱乐部<br />VIP球票×2",
  "*净入金达到 300,000 USD": `*净入金达到 300,000 USD&nbsp;&nbsp; <br class="mobile" /> 
                            累计交易量(手数)达到500手&nbsp;&nbsp; 即可获得`,
  "巴塞罗那足球俱乐部尊享球票×1": "巴塞罗那足球俱乐部<br />尊享球票×1",
  "往返机票×1": "往返机票×1",
  "住宿×3晚": "住宿×3晚",
  "*净入金达到 550,000 USD": `*净入金达到 550,000 USD&nbsp;&nbsp; <br class="mobile" />
                            累计交易量(手数)达到1000手&nbsp;&nbsp; 即可获得`,
  "巴塞罗那足球俱乐部尊享球票×2": "巴塞罗那足球俱乐部<br />尊享球票×2",
  "往返机票×2": "往返机票×2",
  "双人房住宿×3晚": "双人房住宿×3晚",
  IB推荐好友: "IB推荐好友 直达最高豪礼",
  活动期间:
    "活动期间，邀请新好友注册并在一个月内成为实盘用户，即有机会直达最高豪华奖励。",
  "尊享球票×1": "VIP球票×1",
  //   "往返机票×1": "往返机票×1",
  //   "住宿×3晚":"住宿×3晚",
  推荐人数: "推荐人数",
  "尊享球票×2": "VIP球票×2",
  //   "往返机票×2": "往返机票×2",
  //   "双人房住宿×3晚": "双人房住宿×3晚",
  如何获得奖励: "如何获得奖励？",
  登录EBC用户中心: "登录EBC用户中心",
  完成交易: "完成交易/推荐条件",
  联系CS或者BD申请奖励: `联系CS或者<br class="pc" /> BD申请奖励`,
  立即参与·赢取奖励: "立即参与·赢取奖励",
  活动须知: "活动须知",
  ruleList: [
    {
      label: "1.活动时间",
      ul: [" 2025年8月1日 - 2026年4月30日（MT4/MT5时间）"],
      show: false,
      maxHeight: 0,
    },
    {
      label: "2.活动规则",
      ul: [
        " 净入金:账户通过支付渠道累计净存款扣除三方转出后的金额。",
        " 交易量：账户名下所有 PRO/STD 账号的平仓手数汇总（不包含 ETF 及股票）。",
        ` 达成任务目标后需<a
                    href="https://forms.office.com/r/DEEghHNyEW"
                    class="section4-form-btn"
                    target="_blank"
                    >填写表单</a
                  >进行申请。选择的比赛日期，需要在登记日往后至少一个月以上。
      `,
        " 活动支持多次参与，统计周期为登记日前一个月。成功领奖励后，将重置净入金与交易量，重新开始计算下一周期数据。",
        " IB邀请好友活动仅可参与一次（统计周期：全活动期）。",
        " 奖品发放前需保持账户净入金达标，方可领取奖品。",
      ],
      show: false,
      maxHeight: 0,
    },
    {
      label: "3.奖品发放说明",
      ul: [
        " 球票奖品为电子票券，出行类奖品由合作供应商协助预订，细节以最终确认为准。",
        " 奖品数量有限，先到先得；名额用完后将酌情调剂尽可能安排尊享体验。",
        " 奖品按申请的最高等级发放，不可重复领取（例：净入金550,000美元且交易量1000手以上，仅可获得Lv.6奖励）。",
        " 可申请全部联赛场次，若申请西班牙德比场次需按1.2倍系数计算达标条件。",
      ],
      show: false,
      maxHeight: 0,
    },
    {
      label: "4.特别声明",
      ul: [
        " 参与前请确认EBC风险提示、使用条款及交易规则。",
        " EBC严格遵守各司法管辖区法律与监管要求，因监管变动、司法/行政命令或遇赛事调整、航班取消等不可抗力，有权取消或终止活动。",
        " 经系统识别或人工核查，存在异常身份信息、违规交易行为的账户或交易账号，将取消活动资格及奖品发放，恕不另行通知。",
        " 本活动仅限真实有效客户参与，活动规则的最终解释权及条款修改权归 EBC 所有，条款若有更改，恕不另行通知。",
      ],
      show: false,
      maxHeight: 0,
    },
  ],
  高风险交易产品披露:
    "高风险交易产品披露：CFD是复杂的金融产品，可能不适用于所有投资者。投资者使用本金的一部分按比率进行交易，比率的作用是收益和损失都被放大。您的损失可能超过您的本金。您应该结合自身目标、财务状况和风险偏好来衡量上述信息。我们建议您寻求独立意见，确保您在进行投资决策前充分理解其中风险。在交易前，请仔细阅读相关风险披露声明。",
  "2025-26赛季巴塞罗那足球俱乐部联赛":
    "2025-26赛季巴塞罗那足球俱乐部联赛<br /> <span>主场场次</span>",
  datelist: [
    {
      date: "2025年9月14日(周日)",
      a: "巴萨",
      b: "瓦伦西亚",
    },
    {
      date: "2025年9月21日（周日）",
      a: "巴萨",
      b: "赫塔菲",
    },
    {
      date: "2025年9月28日（周日）",
      a: "巴萨",
      b: "皇家社会",
    },
    {
      date: "2025年10月19日（周日）",
      a: "巴萨",
      b: "赫罗纳",
    },
    {
      date: "2025年11月2日（周日）",
      a: "巴萨",
      b: "埃尔切",
    },
    {
      date: "2025年11月23日（周日）",
      a: "巴萨",
      b: "毕尔巴鄂竞技",
    },
    {
      date: "2025年11月30日（周日）",
      a: "巴萨",
      b: "阿拉维斯",
    },
    {
      date: "2025年12月14日（周日）",
      a: "巴萨",
      b: "奥萨苏纳",
    },
    {
      date: "2026年1月11日（周日）",
      a: "巴萨",
      b: "马德里竞技",
    },
    {
      date: "2026年1月25日（周日）",
      a: "巴萨",
      b: "皇家奥维耶多",
    },
    {
      date: "2026年2月8日（周日）",
      a: "巴萨",
      b: "马略卡",
    },
    {
      date: "2026年2月22日（周日）",
      a: "巴萨",
      b: "莱万特",
    },
    {
      date: "2026年3月1日（周日）",
      a: "巴萨",
      b: "比利亚雷亚尔",
    },
    {
      date: "2026年3月15日（周日）",
      a: "巴萨",
      b: "塞维利亚",
    },
    {
      date: "2026年3月22日（周日）",
      a: "巴萨",
      b: "巴列卡诺",
    },
    {
      date: "2026年4月12日（周日）",
      a: "巴萨",
      b: "西班牙人",
    },
    {
      date: "2026年4月22日（周三）",
      a: "巴萨",
      b: "塞尔塔",
    },
    {
      date: "2026年5月10日（周日）",
      a: "巴萨",
      b: "皇家马德里（西班牙德比）",
    },
    {
      date: "2026年5月17日（周日）",
      a: "巴萨",
      b: "皇家贝蒂斯",
    },
  ],
  本页联赛赛程仅表示主场比赛仅在该周末发生:
    "本页联赛赛程仅表示主场比赛仅在该周末发生，具体周六或周日以及开球时间会在开始前1个月左右公布，请关注巴萨官网或者联系cs",
  levelList: [
    { label: "Lv.1", value: "20,000 USD" },
    { label: "Lv.2", value: "40,000 USD" },
    { label: "Lv.3", value: "50,000 USD" },
    { label: "Lv.4", value: "100,000 USD" },
    { label: "Lv.5", value: "300,000 USD <br/>+ 500 手" },
    { label: "Lv.6", value: "550,000 USD <br/>+ 1000 手" },
  ],
  为确保活动的公平与顺利进行:
    "*为确保活动的公平与顺利进行，参与者需在奖品发放前保持账户中达到条件的净入金金额",
  净入金累积达$500:
    "净入金累积达$500，计为达标日当月的有效客户，每位客户最多可计为1次有效客户，多账户也仅计一次。",
};
